module.exports = __webpack_public_path__ + "static/img/19.fe4af99.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/19.jpg
// module id = vbZ6
// module chunks = 0